import {
  useState,
  useEffect
} from 'react';

import moment from 'moment';
import 'moment/locale/id';

import {
  BaseAPI,
} from './BaseAPI';

import localization from '../utils/localizations';
import getCookie from './Cookie';


class LanguageAPI extends BaseAPI {
  path = 'lang/'
}

let languageAPI: LanguageAPI;
function getAPI() {
  if (!languageAPI) languageAPI = new LanguageAPI();
  return languageAPI;
}

function useLanguage(path=''): any[] {
  const [language, setLanguage] = useState(getCookie('app_lang') ? getCookie('app_lang') : 'id');

  const updateLanguage = async (lang: string) => {
    if (lang === 'en-us') {
      moment.locale('en');
    }
    else {
      moment.locale(lang);
    }

    const languageAPI = getAPI();
    setLanguage(lang);
    localization.setLanguage(lang);
    if (window.localStorage) window.localStorage.lang = lang;
    try {
      await languageAPI.get(`${lang}/`);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    updateLanguage(language);
  }, []);

  return [
    language,
    updateLanguage,
  ];
}

export {
  getAPI,
  useLanguage,
};
